var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.3333,
    cy: 64,
    r: 56,
    fill: "#FEF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8333 32C98.8333 31.1716 99.5049 30.5 100.333 30.5L114.333 30.5C115.162 30.5 115.833 31.1716 115.833 32C115.833 32.8284 115.162 33.5 114.333 33.5L100.333 33.5C99.5049 33.5 98.8333 32.8284 98.8333 32Z",
    fill: "#F7BA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83331 82C1.83331 81.1716 2.50489 80.5 3.33331 80.5H17.3333C18.1617 80.5 18.8333 81.1716 18.8333 82C18.8333 82.8284 18.1617 83.5 17.3333 83.5H3.33331C2.50489 83.5 1.83331 82.8284 1.83331 82Z",
    fill: "#F7BA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.833 39C104.833 38.1716 105.505 37.5 106.333 37.5L112.333 37.5C113.162 37.5 113.833 38.1716 113.833 39C113.833 39.8284 113.162 40.5 112.333 40.5L106.333 40.5C105.505 40.5 104.833 39.8284 104.833 39Z",
    fill: "#F7BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83331 89C7.83331 88.1716 8.50489 87.5 9.33331 87.5H15.3333C16.1617 87.5 16.8333 88.1716 16.8333 89C16.8333 89.8284 16.1617 90.5 15.3333 90.5H9.33331C8.50489 90.5 7.83331 89.8284 7.83331 89Z",
    fill: "#F7BA97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.833 32C119.833 31.1716 120.505 30.5 121.333 30.5H125.333C126.162 30.5 126.833 31.1716 126.833 32C126.833 32.8284 126.162 33.5 125.333 33.5H121.333C120.505 33.5 119.833 32.8284 119.833 32Z",
    fill: "#F7BA97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4986 36C56.353 36 49.7496 42.6034 49.7496 50.749C49.7496 58.8946 56.353 65.498 64.4986 65.498C72.6443 65.498 79.2476 58.8946 79.2476 50.749C79.2476 42.6034 72.6443 36 64.4986 36ZM52.7496 50.749C52.7496 44.2602 58.0098 39 64.4986 39C70.9874 39 76.2476 44.2602 76.2476 50.749C76.2476 57.2378 70.9874 62.498 64.4986 62.498C58.0098 62.498 52.7496 57.2378 52.7496 50.749Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.666 71.3306C49.9594 71.3306 45.3333 75.9567 45.3333 81.6632C45.3333 87.3698 49.9594 91.9959 55.666 91.9959H73.3313C79.0379 91.9959 83.664 87.3698 83.664 81.6632C83.664 75.9567 79.0379 71.3306 73.3313 71.3306H55.666ZM48.3333 81.6632C48.3333 77.6135 51.6163 74.3306 55.666 74.3306H73.3313C77.381 74.3306 80.664 77.6135 80.664 81.6632C80.664 85.713 77.381 88.9959 73.3313 88.9959H55.666C51.6163 88.9959 48.3333 85.713 48.3333 81.6632Z",
    fill: "#E9688A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.a96f0d87396efafdd144c8b95f4ce169.svg";
export { ForwardRef as ReactComponent };